export { default as Admin } from './Admin.vue'
export { default as Bills } from './Bills.vue'
export { default as Charges } from './Charges.vue'
export { default as Customers } from './Customers.vue'
export { default as Dashboard } from './Dashboard.vue'
export { default as Forbidden } from './Forbidden.vue'
export { default as Login } from './Login.vue'
export { default as Main } from './Main.vue'
export { default as PageNotFound } from './PageNotFound.vue'
export { default as Properties } from './Properties.vue'
export { default as Records } from './Records.vue'
export { default as Room } from './Room.vue'
export { default as UserProfile } from './UserProfile.vue'
export { default as UserManagement } from './Admin/UserManagement.vue'
export { default as TemplatesManagement } from './Admin/TemplatesManagement.vue'
export { default as RoomsManagement } from './Admin/RoomsManagement.vue'
export { default as MetaManagement } from './Admin/MetaManagement.vue'



// WEBPACK FOOTER //
// ./client/src/pages/index.js